import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { EmptyState, PageHeader } from '@/components/page';
import { Skeleton } from '@/components/ui/skeleton';
import { MonthPicker } from '@/features/time/month-picker';
import { currentMonth } from '@/lib/months';
import { TimesheetEditor } from '@/features/time/timesheet-editor';
import { uk } from '@/i18n/uk';
import { trpc } from '@/lib/trpc';

export const Route = createFileRoute('/_app/me/timesheet')({
  validateSearch: z.object({
    month: z
      .string()
      .regex(/^\d{4}-\d{2}$/)
      .optional()
      .catch(undefined),
  }),
  component: MyTimesheet,
});

function MyTimesheet() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const month = search.month ?? currentMonth();
  const me = useQuery(trpc.me.employee.queryOptions());
  if (me.isPending) return <Skeleton className="h-48" />;
  if (!me.data) return <EmptyState title={uk.cabinet.noEmployee} />;
  return (
    <>
      <PageHeader title={uk.cabinet.timesheet} />
      <div className="mb-3">
        <MonthPicker
          value={month}
          onChange={(m) => void navigate({ search: { month: m }, replace: true })}
        />
      </div>
      <TimesheetEditor employeeId={me.data.id} month={month} />
    </>
  );
}
